import React from "react";
import { useSelector, useDispatch } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { newDate } from "helpers/dateTools";
import { setReportDayFilters, getReportDaysAction } from "redux/actions/Reports/reportDay/reportDayActions";

export const ReportDayView = () => {
  const dispatch = useDispatch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(({ reportDay }) => reportDay);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(getReportDaysAction({ date, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    dispatch(getReportDaysAction({ date, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte del día" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingReportDay ? <LoadingComponent /> :
        <TableInputs
          reducer="reportDay"
          date
          stations
          maxDate={newDate()}
          dispatchAction={setReportDayFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
